import * as PIXI from 'pixi.js';
import { Assets } from '@pixi/assets';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { getImagePath } from '../Util/utils';
import { Live2DModel, config, MotionPriority } from 'pixi-live2d-display/cubism4';
import { expressionData, motionData } from '../Live2d/Live2dData';
import Live2dDetectVoiceMe from '../Live2d/Live2dDetectVoiceMe';
import { SpeechPlayer } from './SpeechPlayer';
import { useRecoilState, useRecoilValue } from 'recoil';
import { mouthShapeAtom } from '../../State';
import DrawText from './DrawText';
window.PIXI = PIXI;

export default function Test() {
  //For Retina Display
  const deviceRatio = window.devicePixelRatio || 1;

  //Reference
  const BASE_WIDTH_Ref = useRef(450); //450
  const BASE_HEIGHT_Ref = useRef(800); // 800
  const pixiRef = useRef(null);
  const wrapRef = useRef(null);
  const canvasRef = useRef(null);
  const modelRef = useRef(null);
  const animeRef = useRef(null);
  const scaleRef = useRef(1);
  const editFontRef = useRef(null);

  //State
  const [viewModeState, setViewModeState] = useState('Playing'); // "Idle", "Playing", "EditText"
  const [aspectState, setAspectState] = useState('portrait'); // "portrait" or "square" or "landscape"
  const [fontState, setFontState] = useState('gothic'); // "gothic" or "mincho" or "round"
  const [fontColorState, setFontColorState] = useState('#000000');
  const [fontStyleState, setFontStyleState] = useState('f1'); //"f0", "f1", "f2", "f3", "f4", "f5", "f6"
  const [objectFitState, setObjectFitState] = useState('cover'); // "contain" or "cover"

  //Temporary Loading
  const [isLoading, setIsLoading] = useState(false);

  //Temporaly form
  const inputWidthRef = useRef(0);
  const inputFontColorRef = useRef('#000000');

  //Temporaly Mouth Movement
  const [mouthState, setMouthState] = useRecoilState(mouthShapeAtom);
  const mouthIntervalRef = useRef(null);

  useEffect(async () => {
    //set animation transition duration
    config.motionFadingDuration = 500;
    config.idleMotionFadingDuration = 500;

    //Init
    initLive2dArea();

    //Temporary
    document.addEventListener('keydown', escFunction, false);

    //createMp3Files();

    // sendElevenLabsData();
  }, []);

  async function makeMp3(text, voice_id, language, pitch, speed) {
    const voiceID = voice_id.substring(2);

    const TTS_URL = 'https://enqqmkzbihekepmwgkxy.supabase.co/functions/v1/uploadMp3';
    const ANON_KEY =
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVucXFta3piaWhla2VwbXdna3h5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTMyOTMzMjMsImV4cCI6MjAwODg2OTMyM30.eq6c496Ujcsk_SaGYYpIZ-M4MsaoV0IPhCujRLfOWG8';

    const headers = {
      Authorization: 'Bearer ' + ANON_KEY,
      'Content-Type': 'application/json',
    };
    const body = JSON.stringify({
      text: text,
      voice_id: voiceID,
      language: language,
      pitch: pitch,
      speed: speed,
    });

    let response;
    try {
      response = await fetch(TTS_URL, {
        method: 'POST',
        headers: headers,
        body: body,
      });

      if (!response.ok) {
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (err) {
      //alert(err);
    }
  }

  async function createMp3Files() {
    var array0 = [
      'zh0',
      'zh1',
      'zh2',
      'zh3',
      'zh4',
      'zh5',
      'zh6',
      'zh7',
      'zh8',
      'zh9',
      'zh10',
      'zh11',
      'zh12',
      'zh13',
      'zh14',
      'zh15',
      'zh16',
      'zh17',
    ];

    var array1 = [
      -2, -1.8, -1.6, -1.4, -1.2, -1, -0.8, -0.6, -0.4, -0.2, 0, 0.2, 0.4, 0.6, 0.8, 1, 1.2, 1.4,
      1.6, 1.8, 2,
    ];
    var array2 = [
      -2, -1.8, -1.6, -1.4, -1.2, -1, -0.8, -0.6, -0.4, -0.2, 0, 0.2, 0.4, 0.6, 0.8, 1, 1.2, 1.4,
      1.6, 1.8, 2,
    ];

    const multipliedResults = [];

    for (const val0 of array0) {
      for (const val1 of array1) {
        for (const val2 of array2) {
          multipliedResults.push([val0, val1, val2]);
        }
      }
    }
    for (const m of multipliedResults) {
      //console.log(m[0], m[1], m[2]);
      await makeMp3('你好吗？今天天气是晴天。', m[0], 'zh', m[1], m[2]);
      await new Promise((resolve) => setTimeout(resolve, 10)); // 1秒待つ
    }

    //let m = multipliedResults[0];
    //await makeMp3('こんにちは。今日の天気は晴れですか？', 'ja0', 'ja', m[0], m[1]);
    //await textToSpeech('こんにちは。今日の天気は晴れですか？', 'ja0', 'ja', m[0], m[1]);
  }

  // async function uploadToS3(arrayBuffer, voiceID, language, pitch, speed) {
  //   const AWSACCESSKEY = 'AKIAZMJ755GBGXJ4ZW7F';
  //   const AWSSECRETKEY = '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';
  //   const AWSREGION = 'ap-northeast-1';
  //   const BUCKETNAME = 'branded-storage';

  //   const blob = new Blob([arrayBuffer], { type: 'audio/mp3' });
  //   const fileName =
  //     'voice/' +
  //     language +
  //     '/' +
  //     language +
  //     String(voiceID) +
  //     '/' +
  //     language +
  //     String(voiceID) +
  //     String(pitch) +
  //     String(speed) +
  //     '.mp3'; // この名前を変更するか、動的に生成してください。

  //   const s3 = new S3Client({
  //     credentials: {
  //       accessKeyId: AWSACCESSKEY,
  //       secretAccessKey: AWSSECRETKEY,
  //     },
  //     region: AWSREGION,
  //   });

  //   const params = {
  //     Bucket: BUCKETNAME,
  //     Key: fileName,
  //     Body: blob,
  //     ContentType: 'audio/mp3',
  //   };

  //   try {
  //     await s3.send(
  //       new PutObjectCommand({
  //         Bucket: BUCKETNAME,
  //         Key: fileName,
  //         Body: blob,
  //         ContentType: 'audio/mp3',
  //       }),
  //     );
  //   } catch (error) {
  //     console.log('エラーだよ');
  //     console.error('Error uploading image to S3:', error);
  //     //throw new Error(`Failed to upload image to S3: ${error.message}`);
  //   }
  // }

  async function saveMp3(arrayBuffer, voiceID, language, pitch, speed) {
    // ArrayBufferをBlobに変換
    const blob = new Blob([arrayBuffer], { type: 'audio/mpeg' });

    // BlobからオブジェクトURLを作成
    const url = window.URL.createObjectURL(blob);

    // aタグを作成して、Blob URLをダウンロードリンクとして設定
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = language + String(voiceID) + String(pitch) + String(speed) + '.mp3';

    // aタグをDOMに追加
    document.body.appendChild(a);

    // ダウンロードリンクをクリック
    a.click();

    // aタグをDOMから削除
    document.body.removeChild(a);

    // Blob URLを解放
    window.URL.revokeObjectURL(url);
  }

  async function textToSpeech(text, voice_id, language, pitch, speed) {
    const TTS_URL = 'https://enqqmkzbihekepmwgkxy.supabase.co/functions/v1/textToSpeech';
    const ANON_KEY =
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVucXFta3piaWhla2VwbXdna3h5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTMyOTMzMjMsImV4cCI6MjAwODg2OTMyM30.eq6c496Ujcsk_SaGYYpIZ-M4MsaoV0IPhCujRLfOWG8';

    const headers = {
      Authorization: 'Bearer ' + ANON_KEY,
      'Content-Type': 'application/json',
    };
    const body = JSON.stringify({
      text: text,
      voice_id: voice_id,
      language: language,
      pitch: pitch,
      speed: speed,
    });

    let response;
    try {
      response = await fetch(TTS_URL, {
        method: 'POST',
        headers: headers,
        body: body,
      });
      if (!response.ok) {
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (err) {
      //alert(err);
    }

    const arrayBuffer = await response.arrayBuffer();

    //uploadToS3(arrayBuffer, voice_id, language, pitch, speed);
    //saveMp3(arrayBuffer, voice_id, language, pitch, speed);
    return arrayBuffer;
  }

  useEffect(() => {
    setAspectRatio(aspectState);
  }, [aspectState, viewModeState]);

  useEffect(() => {
    if (viewModeState == 'EditFont') {
      funcSetViewMode('EditFont');
    }
  }, [fontState, fontStyleState, fontColorState]);

  //Keyboard emote dummy
  const escFunction = useCallback(async (event) => {
    if (modelRef.current == null) return;

    config.motionFadingDuration = 0;
    addMotion('reset');
    addMotion('Idle');

    console.log(event.keyCode);

    // if (event.keyCode === 49) {
    //   if (event.keyCode === 50) addMotion('heart');
    // } else {
    //   config.motionFadingDuration = 500;
    // }
    if (event.keyCode === 49) addMotion('hi');
    if (event.keyCode === 50) addMotion('heart');
    if (event.keyCode === 51) addMotion('smile');
    if (event.keyCode === 52) addMotion('gaan');
    if (event.keyCode === 53) addMotion('hatena');
    if (event.keyCode === 54) addMotion('surprise');
    if (event.keyCode === 55) addMotion('confetti');
    if (event.keyCode === 56) addMotion('doya');
    if (event.keyCode === 57) addMotion('aseru');
    if (event.keyCode === 48) addMotion('hana'); // 0
    if (event.keyCode === 81) addMotion('test1'); // Q
    if (event.keyCode === 87) addMotion('test1'); // W
    //if (event.keyCode === 0) modelRef.current.internalModel.motionManager.groups.idle = 'heart';
  }, []);

  function addMotion(motionName) {
    modelRef.current.motion(motionName, undefined, MotionPriority.FORCE);
    if (animeRef.current != null) {
      animeRef.current.motion(motionName, undefined, MotionPriority.FORCE);
    }
  }

  function setAspectRatio(aspectState) {
    if (aspectState == 'square') {
      BASE_WIDTH_Ref.current = 600;
      BASE_HEIGHT_Ref.current = 600;

      wrapRef.current.style.width = 600 + 'px';
      wrapRef.current.style.height = 600 + 'px';

      setCanvasSize(600, 600);
    }
    if (aspectState == 'portrait') {
      BASE_WIDTH_Ref.current = 450;
      BASE_HEIGHT_Ref.current = 800;

      wrapRef.current.style.width = 450 + 'px';
      wrapRef.current.style.height = 800 + 'px';
      setCanvasSize(450, 800);
    }

    if (aspectState == 'landscape') {
      BASE_WIDTH_Ref.current = 800;
      BASE_HEIGHT_Ref.current = 450;

      wrapRef.current.style.width = 800 + 'px';
      wrapRef.current.style.height = 450 + 'px';
      setCanvasSize(800, 450);
    }
  }

  async function initLive2dArea() {
    // let array = [5];

    // array.forEach(async (a) => {
    //   console.log(a);
    //   await textToSpeech('こんにちは。今日の天気は晴れですか？', a, 'ja');
    // });

    // return;

    if (pixiRef.current != null) return;

    pixiRef.current = new PIXI.Application({
      width: BASE_WIDTH_Ref.current,
      height: BASE_HEIGHT_Ref.current,
      view: canvasRef.current,
      autoStart: true,
      backgroundColor: 0xe9c9ff,
      resizeTo: wrapRef.current,
      //autoResize: true,
      resolution: deviceRatio,
      autoDensity: true,
      antialias: true,
    });

    pixiRef.current.renderer.on('resize', (width, height) => {
      //if (currentHeightRef.current != height && currentWidthRef.current != width)
      //setCanvasSize(width, height);
    });

    //available to sort
    pixiRef.current.stage.sortableChildren = true;
    pixiRef.current.ticker.minFPS = 10;
    pixiRef.current.ticker.maxFPS = 30;

    //load model
    await loadLive2DModel();

    //load emote model
    await loadAnimeModel();
  }

  function setCanvasSize(width, height) {
    //calculate scale
    const scaleX = width / BASE_WIDTH_Ref.current;
    const scaleY = height / BASE_HEIGHT_Ref.current;

    //setScaleState(scaleX);
    scaleRef.current = scaleX;

    //change scale
    pixiRef.current.stage.scale.x = scaleX;
    pixiRef.current.stage.scale.y = scaleY;

    //resize canvas
    pixiRef.current.renderer.resize(width, height);

    setModelPosition('bottom');
  }

  async function loadLive2DModel(modelID) {
    //let modelURL =
    'https://d2wp3sepl8g4xv.cloudfront.net/live2d/ethereum-0x04b392cc6cda280c41e6fd637359f6d7f3ecbc30-original3/base.model3.json';
    //let modelURL = 'https://d2wp3sepl8g4xv.cloudfront.net/kobayashikiyo/basic/base.model3.json';

    let modelURL;
    if (modelID == null) {
      modelURL = 'https://faceless.hiho.jp/kobayashi/base.model3.json';
    } else {
      modelURL = 'https://faceless.hiho.jp/kobayashi/' + modelID + '/base.model3.json';
    }

    let json;
    json = await fetch(modelURL).then((res) => res.json());
    json.url = modelURL;
    json.FileReferences.Motions = motionData;

    //モーションの設定の上書き

    var motionJson = 'https://faceless.hiho.jp/kobayashi-motions/motion-list2.json';

    await fetch(motionJson, { method: 'GET' })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        json.FileReferences.Motions = data;
      });

    json.FileReferences.Expressions = expressionData;

    if (modelRef.current != null) {
      pixiRef.current.stage.removeChild(modelRef.current);
      modelRef.current = null;
    }

    modelRef.current = await Live2DModel.from(json, {
      autoInteract: false,
    });

    modelRef.current.zIndex = 4;
    pixiRef.current.stage.addChild(modelRef.current);
    modelRef.current.internalModel.motionManager.groups.idle = 'Idle';

    setModelPosition('bottom');

    if (mouthIntervalRef.current != null) {
      clearInterval(mouthIntervalRef.current);
    }

    mouthIntervalRef.current = setInterval(() => {
      const randomValue = Math.random();
      setMouthState(randomValue);
    }, 100);
  }

  async function loadAnimeModel() {
    //Load Live2D model for animation
    let modelURL = 'https://faceless.hiho.jp/kobayashi-anime/base.model3.json';
    let json;
    try {
      json = await fetch(modelURL).then((res) => res.json());
      json.url = modelURL;
    } catch (err) {
      console.log('エラーだよ');
      return;
    }

    var motionJson = 'https://faceless.hiho.jp/kobayashi-anime/motions/motion-list.json';

    try {
      await fetch(motionJson, { method: 'GET' })
        .then((res) => res.json())
        .then((data) => {
          json.FileReferences.Motions = data;
        })
        .catch((err) => {
          throw 'erro';
        });
    } catch (err) {
      return;
    }

    animeRef.current = await Live2DModel.from(json, {
      autoInteract: false,
    });

    animeRef.current.zIndex = 5;
    pixiRef.current.stage.addChild(animeRef.current);
    animeRef.current.internalModel.motionManager.groups.idle = 'Idle';

    setModelPosition('bottom', animeRef.current);
  }

  function setModelPosition(position) {
    var refArray = [modelRef.current, animeRef.current];

    refArray.forEach((ref) => {
      if (ref != null) {
        if (aspectState == 'square') {
          if (position == 'bottom') {
            ref.x = pixiRef.current.view.width / deviceRatio / 2 / scaleRef.current;
            ref.y = pixiRef.current.view.height / deviceRatio / scaleRef.current;
            ref.scale.set(1, 1);
            ref.anchor.set(0.5, 1);
          } else {
            ref.x = 0;
            ref.y = pixiRef.current.view.height / deviceRatio / scaleRef.current;
            ref.scale.set(0.6, 0.6);
            ref.anchor.set(0, 1);
          }
        }
        if (aspectState == 'portrait') {
          if (position == 'bottom') {
            ref.x = pixiRef.current.view.width / deviceRatio / 2 / scaleRef.current;
            ref.y = pixiRef.current.view.height / deviceRatio / scaleRef.current;
            if (viewModeState == 'EditFont') {
              ref.scale.set(1, 1);
            } else {
              ref.scale.set(1.2, 1.2);
            }
            ref.anchor.set(0.5, 1);
          } else {
            ref.x = pixiRef.current.view.width / deviceRatio / 2 / scaleRef.current;
            ref.y = pixiRef.current.view.height / deviceRatio / scaleRef.current;
            ref.scale.set(0.6, 0.6);
            ref.anchor.set(0.5, 1);
          }
        }
        if (aspectState == 'landscape') {
          if (position == 'bottom') {
            ref.x = pixiRef.current.view.width / deviceRatio / 2 / scaleRef.current;
            ref.y = pixiRef.current.view.height / deviceRatio / scaleRef.current;
            ref.scale.set(0.8, 0.8);
            ref.anchor.set(0.5, 1);
          } else {
            ref.x = 0;
            ref.y = pixiRef.current.view.height / deviceRatio / scaleRef.current;
            ref.scale.set(0.5, 0.5);
            ref.anchor.set(0, 1);
          }
        }
      }
    });
  }

  function copyArrayBuffer(sourceBuffer) {
    const copy = new ArrayBuffer(sourceBuffer.byteLength);
    new Uint8Array(copy).set(new Uint8Array(sourceBuffer));
    return copy;
  }

  async function startPlay2() {
    const buffer1 = await textToSpeech('hello how are you doing. I am from osaka', 1);
    const buffer2 = await textToSpeech('I am fine thank you and you?', 2);

    const player = new SpeechPlayer(modelRef.current);
    let duration1 = await player.preloadFromBuffer(1, buffer1);
    let duration2 = await player.preloadFromBuffer(2, buffer2);

    player.play(1);
    await delay(duration1);
    player.play(2);
    await delay(duration2);
    player.stopAll();
  }

  async function startPlay3() {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const analyser = audioContext.createAnalyser();
    var lastTime = 0;
    const fpsInterval = 1000 / 10; // 10fps

    async function loadLocalFile(filePath) {
      const response = await fetch(filePath);
      const arrayBuffer = await response.arrayBuffer();

      return arrayBuffer;
    }

    async function playLocalFile(filePath) {
      const buffer = await loadLocalFile(filePath);
      await playBuffer(buffer);
    }

    function playBuffer(buffer) {
      return new Promise((resolve, reject) => {
        audioContext.decodeAudioData(
          buffer,

          (decodedData) => {
            const analyser = audioContext.createAnalyser();
            const sampleSource = audioContext.createBufferSource();
            sampleSource.buffer = decodedData;

            const bufferLength = analyser.frequencyBinCount;
            const dataArray = new Uint8Array(bufferLength);

            sampleSource.connect(analyser);
            analyser.connect(audioContext.destination);
            sampleSource.start();

            function caclculateVolume() {
              analyser.getByteFrequencyData(dataArray);

              let sum = 0;
              for (const amplitude of dataArray) {
                sum += amplitude * amplitude;
              }

              const volume = Math.sqrt(sum / dataArray.length);
              console.log(volume);
              requestAnimationFrame(caclculateVolume);
            }

            caclculateVolume();
          },
          (error) => {
            console.error('Error decoding audio data:', error);
          },
        );
      });
    }

    function getAudioData(timestamp) {
      const elapsed = timestamp - lastTime;
      const threshold = 5; // この値は調整が必要です

      if (elapsed > fpsInterval) {
        lastTime = timestamp - (elapsed % fpsInterval);

        const dataArray = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(dataArray);

        // 平均値を取得
        const average = dataArray.reduce((acc, val) => acc + val, 0) / dataArray.length;

        // 最大値を取得
        const max = Math.max(...dataArray);

        const adjustedAverage = average < threshold ? 0 : average;
        const adjustedMax = max < threshold ? 0 : max;

        //console.log('Average Volume:', average);
        console.log('Max Volume:', adjustedMax);
      }
      //

      // ここでdataArrayを使用して音の変化を処理します
      //requestAnimationFrame(getAudioData);
    }

    // ローカルのmp3ファイルを再生
    playLocalFile(getImagePath() + '/studio/jenny6.mp3').then(() => {
      console.log('File played!');
    });

    // 音の変化を取得し続ける
    //getAudioData();
    requestAnimationFrame(getAudioData);
  }

  async function sendElevenLabsData() {
    let string = 'ありがとうございます！明日の天気は晴れですか？';
    let voiceID = 'tqWKmFCJa7uDELIpdmmh'; //'DRfx2qDtrKcN07PeLDD6';
    const url =
      'https://api.elevenlabs.io/v1/text-to-speech/' + voiceID + '?optimize_streaming_latency=0'; // 送信先のURL
    const data = {
      text: string,
      model_id: 'eleven_multilingual_v2',
      voice_settings: {
        stability: 0.8,
        similarity_boost: 0.8,
        style: 0,
        use_speaker_boost: true,
      },
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          accept: 'audio/mpeg',
          'xi-api-key': '458b3fe97d608c157e7f32fbc607ff18',
        },
        body: JSON.stringify(data),
      });

      console.log(response);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const audioBlob = await response.blob();

      //download file
      const audioUrl = URL.createObjectURL(audioBlob);
      const link = document.createElement('a');
      link.href = audioUrl;
      link.download = 'audio.mp3';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error.message);
    }
  }

  async function startPlay() {
    await startPlay2();

    return;

    setIsLoading(true);
    //preload  -------------------------
    let voice1 = await preloadAudio('/studio/jenny1.mp3', 0.8);
    let voice2 = await preloadAudio('/studio/jenny2.mp3', 0.8);
    let voice3 = await preloadAudio('/studio/jenny3.mp3', 0.8);
    let voice4 = await preloadAudio('/studio/jenny4.mp3', 0.8);
    let voice5 = await preloadAudio('/studio/jenny5.mp3', 0.8);
    let voice6 = await preloadAudio('/studio/jenny6.mp3', 0.8);
    let voice7 = await preloadAudio('/studio/jenny7.mp3', 0.8);
    let voice8 = await preloadAudio('/studio/jenny8.mp3', 0.8);
    let bgm = await preloadAudio('/studio/bgm.mp3', 0.3);
    let image2 = await addImage('/studio/j5.png');
    let image3 = await addImage('/studio/j6.png');
    let image4 = await addImage('/studio/j3.png');
    let video1 = await addVideo('/studio/j10.mp4');
    let video2 = await addVideo('/studio/j11.mp4');

    setIsLoading(false);

    //Dummy mouth move start
    if (mouthIntervalRef.current != null) {
      clearInterval(mouthIntervalRef.current);
      mouthIntervalRef.current = null;
    }
    mouthIntervalRef.current = setInterval(() => {
      const randomValue = Math.random();
      setMouthState(randomValue);
    }, 100);

    //Change model animation to talking mode
    modelRef.current.internalModel.motionManager.groups.idle = 'Acting';

    //Scene1 -------------------------
    //addMotion('surprise');
    const bubble1 = DrawText(
      '今日はよろしく！',
      pixiRef.current,
      'bottom',
      fontState,
      fontColorState,
      fontStyleState,
      aspectState,
      scaleRef.current,
    );
    bgm.play();
    voice1.play();

    await delay(1500);

    //Scene2 -------------------------
    pixiRef.current.stage.removeChild(bubble1);
    voice2.play();
    image2.visible = true;
    //addMotion('kirakira');
    const bubble2 = DrawText(
      'I love Japan',
      pixiRef.current,
      'left',
      fontState,
      fontColorState,
      fontStyleState,
      aspectState,
      scaleRef.current,
    );
    //bubble2.zIndex = 1;
    setModelPosition('left');

    await delay(1000);

    //Scene3 -------------------------
    pixiRef.current.stage.removeChild(image2);
    pixiRef.current.stage.removeChild(bubble2);

    voice3.play();
    image3.visible = true;
    const bubble3 = DrawText(
      'because I love sushi',
      pixiRef.current,
      'left',
      fontState,
      fontColorState,
      fontStyleState,
      aspectState,
      scaleRef.current,
    );
    //addMotion('smile');
    //bubble3.zIndex = 1;

    await delay(1000);

    //Scene4 -------------------------
    pixiRef.current.stage.removeChild(image3);
    pixiRef.current.stage.removeChild(bubble3);

    voice4.play();
    image4.visible = true;
    const bubble4 = DrawText(
      'and ramen noodles',
      pixiRef.current,
      'left',
      fontState,
      fontColorState,
      fontStyleState,
      aspectState,
      scaleRef.current,
    );
    //bubble4.zIndex = 1;

    await delay(1000);

    //Scene5 -------------------------
    pixiRef.current.stage.removeChild(image4);
    pixiRef.current.stage.removeChild(bubble4);

    setModelPosition('bottom');
    // const scary = await addScary(scaryTexture);
    //addMotion('gaan');
    const bubble5 = DrawText(
      ',but I hate Tempura',
      pixiRef.current,
      'bottom',
      fontState,
      fontColorState,
      fontStyleState,
      aspectState,
      scaleRef.current,
    );
    voice5.play();

    await delay(1500);

    //Scene6 -------------------------
    //pixiRef.current.stage.removeChild(scary);
    pixiRef.current.stage.removeChild(bubble5);

    setModelPosition('left');
    voice6.play();
    //const heartInterval = await addHeartEffect(heart);
    //modelRef.current.motion('hatena', undefined, MotionPriority.FORCE);
    video1.visible = true;
    const bubble6 = DrawText(
      'This is my job, working as a hair dresser. I really like this',
      pixiRef.current,
      'left',
      fontState,
      fontColorState,
      fontStyleState,
      aspectState,
      scaleRef.current,
    );

    await delay(2400);

    //Scene7 -------------------------

    //clearInterval(heartInterval);
    pixiRef.current.stage.removeChild(bubble6);
    pixiRef.current.stage.removeChild(video1);

    setModelPosition('bottom');
    voice7.play();

    //addMotion('angry');
    const bubble7 = DrawText(
      'if you are interested in me,',
      pixiRef.current,
      'bottom',
      fontState,
      fontColorState,
      fontStyleState,
      aspectState,
      scaleRef.current,
    );

    await delay(1300);

    //Scene8 -------------------------

    pixiRef.current.stage.removeChild(bubble7);

    video2.visible = true;

    setModelPosition('left');
    voice8.play();
    //addMotion('doya');
    const bubble8 = DrawText(
      'follow me on instagram',
      pixiRef.current,
      'left',
      fontState,
      fontColorState,
      fontStyleState,
      aspectState,
      scaleRef.current,
    );
    await delay(1500);

    pixiRef.current.stage.removeChild(video2);
    pixiRef.current.stage.removeChild(bubble8);
    stopAudio(bgm);

    //Reset
    setModelPosition('bottom');
    //Change model animation to idle mode
    modelRef.current.internalModel.motionManager.groups.idle = 'Idle';

    //stop mouse movement
    if (mouthIntervalRef.current != null) {
      clearInterval(mouthIntervalRef.current);
      mouthIntervalRef.current = null;
    }
  }

  async function preloadAudio(path, volume) {
    return new Promise((resolve, reject) => {
      const audio = new Audio(getImagePath() + path);
      audio.volume = volume; //0.15;

      audio.addEventListener(
        'canplaythrough',
        function () {
          resolve(audio);
        },
        false,
      );

      audio.addEventListener(
        'error',
        function () {
          reject(new Error('Audio preload failed')); // エラーが発生した場合、Promiseを拒否
        },
        false,
      );

      audio.load();
    });
  }

  function stopAudio(audio) {
    audio.pause();
    audio.src = '';
    audio.remove();
  }

  async function addImage(path) {
    let texture;
    let loadURL = getImagePath() + path;
    texture = await Assets.load(loadURL);
    return setImageVideo(texture);
  }

  async function addVideo(path) {
    let texture;
    try {
      texture = await loadTextureAsync(getImagePath() + path);
      texture.baseTexture.resource.source.loop = true;
      //texture.baseTexture.resource.source.play();
      console.log('Texture loaded:', texture);
    } catch (error) {
      console.error('Error loading texture:', error);
    }
    return setImageVideo(texture);
  }

  async function setImageVideo(texture) {
    let bgSprite = new PIXI.Sprite(texture);

    const canvasRatio = pixiRef.current.view.width / pixiRef.current.view.height;
    const imageRatio = bgSprite.width / bgSprite.height;

    //Cover
    if (objectFitState == 'cover') {
      if (imageRatio > canvasRatio) {
        bgSprite.height = pixiRef.current.view.height / deviceRatio / scaleRef.current;
        bgSprite.width = bgSprite.height * imageRatio;
      } else {
        bgSprite.width = pixiRef.current.view.width / deviceRatio / scaleRef.current;
        bgSprite.height = bgSprite.width / imageRatio;
      }
    }

    //Contain
    if (objectFitState == 'contain') {
      if (bgSprite.height >= bgSprite.width) {
        bgSprite.height = pixiRef.current.view.height / deviceRatio / scaleRef.current;
        bgSprite.width = bgSprite.height * imageRatio;
      } else {
        bgSprite.width = pixiRef.current.view.width / deviceRatio / scaleRef.current;
        bgSprite.height = bgSprite.width / imageRatio;
      }
    }

    bgSprite.anchor.set(0.5, 0.5);
    bgSprite.position.set(
      pixiRef.current.view.width / 2 / deviceRatio / scaleRef.current,
      pixiRef.current.view.height / 2 / deviceRatio / scaleRef.current,
    );

    // Add black background
    const graphics = new PIXI.Graphics();
    graphics.beginFill(0x000000); // 黒色
    graphics.drawRect(
      0,
      0,
      pixiRef.current.view.width * deviceRatio,
      pixiRef.current.view.height * deviceRatio,
    );
    graphics.endFill();
    const backtexture = pixiRef.current.renderer.generateTexture(graphics);
    const backsprite = new PIXI.Sprite(backtexture);

    const container = new PIXI.Container();
    container.sortableChildren = true;
    container.zIndex = 1;
    container.addChild(backsprite);
    container.addChild(bgSprite);

    pixiRef.current.stage.addChild(container);
    container.visible = false;

    return container;
  }

  async function loadTextureAsync(path) {
    return new Promise((resolve, reject) => {
      let texture = PIXI.Texture.from(path);

      if (texture.baseTexture.valid) {
        // テクスチャがすでにロードされている場合
        resolve(texture);
      } else {
        texture.baseTexture.on('loaded', () => {
          resolve(texture);
        });
        texture.baseTexture.on('error', (err) => {
          reject(err);
        });
      }
    });
  }

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const handleAvatarChange = async (event) => {
    await loadLive2DModel(event.target.value);
  };

  const handleAspectChange = (event) => {
    funcSetAspectRatio(event.target.value);
  };

  const handleFontChange = (event) => {
    funcSetFontFamily(event.target.value);
  };

  const handleFontStyleChange = (event) => {
    funcSetFontStyle(event.target.value);
  };

  const sendFontColor = (event) => {
    event.preventDefault();
    const value = inputFontColorRef.current.value;
    funcSetFontColor(value);
  };

  const sendCanvasSize = (event) => {
    event.preventDefault();
    const widthValue = inputWidthRef.current.value;
    funcSetCanvasSize(widthValue);
  };

  const handleViewModeChange = (event) => {
    funcSetViewMode(event.target.value);
  };

  /*----------------- Public Function Start --------------- */

  function funcSetAspectRatio(aspect) {
    setAspectState(aspect);
  }

  function funcSetFontFamily(value) {
    setFontState(value);
  }

  function funcSetFontStyle(value) {
    setFontStyleState(value);
  }

  function funcSetFontColor(color) {
    setFontColorState(color);
  }

  function funcSetCanvasSize(widthValue) {
    if (aspectState == 'square') {
      wrapRef.current.style.width = widthValue + 'px';
      wrapRef.current.style.height = widthValue + 'px';

      setCanvasSize(widthValue, widthValue);
    }

    if (aspectState == 'portrait') {
      wrapRef.current.style.width = widthValue + 'px';
      wrapRef.current.style.height = (16 * widthValue) / 9 + 'px';

      setCanvasSize(widthValue, (16 * widthValue) / 9);
    }

    if (aspectState == 'landscape') {
      wrapRef.current.style.width = widthValue + 'px';
      wrapRef.current.style.height = (9 * widthValue) / 16 + 'px';

      setCanvasSize(widthValue, (9 * widthValue) / 16);
    }
  }

  function funcSetViewMode(mode, text = 'Sample Text') {
    //Remove existing text
    if (editFontRef.current != null) {
      pixiRef.current.stage.removeChild(editFontRef.current);
      editFontRef.current = null;
    }

    if (mode == 'EditFont') {
      setAspectRatio('portrait');

      //Show Text
      editFontRef.current = DrawText(
        text,
        pixiRef.current,
        'center',
        fontState,
        fontColorState,
        fontStyleState,
        aspectState,
        scaleRef.current,
      );
    }
    setViewModeState(mode);
  }

  /*----------------- Public Function End --------------- */

  return (
    <>
      <div id="canvasWrapBox" ref={wrapRef}>
        {isLoading && (
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              backgroundColor: '#000',
              opacity: 0.5,
              textAlign: 'center',
              color: 'white',
              fontSize: '30px',
              top: '0%',
              left: '0%',
              paddingTop: '280px',
            }}>
            Loading
          </div>
        )}
        <canvas ref={canvasRef} onClick={startPlay}></canvas>
      </div>
      <Live2dDetectVoiceMe modelRef={modelRef} />
      <div id="canvasTempBox">
        <div id="canvasAvatar">
          <select value={aspectState} onChange={handleAvatarChange}>
            <option>アバター選択</option>
            <option value="koaram">コアラ</option>
            <option value="hukurou">ふくろう</option>
            <option value="tamago">うさぎ</option>
            <option value="hituji">ひつじ</option>
            <option value="gaikotuf">ガイコツ</option>
            <option value="haraf">Hara女性</option>
            <option value="haram">Hara男性</option>
            <option value="Disney">ディズニー女性</option>
            <option value="Disneym">ディズニー男性</option>
            <option value="hoppef">ほっぺ</option>
            <option value="Oliviaf">Olivia女性</option>
          </select>
        </div>

        <div id="canvasSwitch">
          <select value={aspectState} onChange={handleAspectChange}>
            <option value="portrait">Portrait</option>
            <option value="square">Square</option>

            <option value="landscape">Landscape</option>
          </select>
        </div>

        <div id="canvasFont">
          <select value={fontState} onChange={handleFontChange}>
            <option value="gothic">Gothic</option>
            <option value="mincho">Mincho</option>
            <option value="round">Round</option>
          </select>
        </div>

        <div id="canvasFontStyle">
          <select value={fontStyleState} onChange={handleFontStyleChange}>
            <option value="f0">No Text</option>
            <option value="f1">Style1</option>
            <option value="f2">Style2</option>
            <option value="f3">Style3</option>
            <option value="f4">Style4</option>
            <option value="f5">Style5</option>
            <option value="f6">Style6</option>
          </select>
        </div>
        <br />
        <div id="canvasSizeSet">
          <input
            type="text"
            ref={inputFontColorRef}
            placeholder="#000000"
            style={{ width: '100px', display: 'inline-block' }}
          />
          <button
            style={{
              display: 'inline-block',
              backgroundColor: '#000',
              color: '#fff',
              padding: '2px',
            }}
            onClick={sendFontColor}>
            Send
          </button>
        </div>
        <div id="canvasSizeSet">
          <input
            type="text"
            ref={inputWidthRef}
            placeholder="width (ex 200)"
            style={{ width: '100px', display: 'inline-block' }}
          />
          <button
            style={{
              display: 'inline-block',
              backgroundColor: '#000',
              color: '#fff',
              padding: '2px',
            }}
            onClick={sendCanvasSize}>
            Send
          </button>
        </div>

        <div id="canvasFontStyle">
          <select value={viewModeState} onChange={handleViewModeChange}>
            <option value="Idle">Idle</option>
            <option value="Playing">Playing</option>
            <option value="EditFont">Edit Font</option>
          </select>
        </div>
      </div>
    </>
  );
}
